import { DEFAULT_LOCALE } from './constants';

export const pluralRules = new Intl.PluralRules(DEFAULT_LOCALE);
